module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Currency":"Валюта","rate_to_currency":"Курс к {0}"},"en":{"rate_to_currency":"Rate to {0}"}}')
  delete Component.options._Ctor
}
